import { Box, Breadcrumbs, Link, Tab, Tabs, Typography } from "@mui/material";
import { BackButton } from "../../../../../common/components/back_button";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";
import { Link as LinkTo } from 'react-router';
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useFuncionariosCadastroViewModel } from "../../viewModels/funcionarios_cadastro_view_model";
import { TabInformacoesGeraisContent } from "./components/tab_informacoes_gerais_content";
import { CadastroCentroCustoSecundarioModal } from "./components/cadastro_centro_custo_secundario_modal";
import { CadastroDocumentoModal } from "./components/cadastro_documento_modal";
import { TabTreinamentosContent } from "./components/tab_treinamentos_content";
import { CadastroTreinamentoModal } from "./components/cadastro_treinamento_modal";
import { AvaliarTreinamentoModal } from "./components/avaliar_treinamento_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { DocumentoModal } from "./components/documento_modal";



export const FuncionariosTercCadastro = () => {
  const viewModel = useFuncionariosCadastroViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <BackButton
              onClick={viewModel.handleBack} />
          }
        />
      </PageTopBar>

      <form className="pb-8" onSubmit={viewModel.handleSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Terceirização
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to='/FuncionarioTercerizacao_lista'>Funcionários</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Funcionário
            </Typography>
          </Breadcrumbs>

          <div>
            <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
              <div className="flex gap-2 items-center w-full">
                <h1 className="text-3xl font-medium text-black dark:text-white">Cadastro de Funcionário</h1>
                <RefreshButton onClick={viewModel.handleReloadPage} />
              </div>

              <div className="w-full justify-end flex gap-2">

              </div>
            </div>

            {viewModel.funcionario && (
              <div className="w-full mt-2 text-black dark:text-white">
                <span className="font-extrabold text-xl mr-2">Funcionário(a):</span>
                <span className="mx-1 font-bold text-xl">{viewModel.funcionario.Nome}</span>
                <span className="mx-1 font-light text-xl">|</span>
              </div>
            )}
          </div>
          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReloadPage} />
                </div>
              ) : (
                <div className="relative bg-transparent mb-8">
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                      variant="scrollable"
                      scrollButtons="auto"
                      slotProps={{
                        startScrollButtonIcon: {
                          className: "text-black dark:text-white",
                        },
                        endScrollButtonIcon: {
                          className: "text-black dark:text-white",
                        },
                        indicator: {
                          style: {
                            background: '#009C4E',
                          }
                        }
                      }}
                      value={viewModel.currentTab}
                      onChange={viewModel.handleTabChange}>
                      <Tab
                        sx={{
                          textTransform: "none",
                          '&.Mui-selected': {
                            color: '#009C4E',
                          },
                        }}
                        label="Informações Gerais"
                        value={1} />

                      <Tab
                        sx={{
                          textTransform: "none",
                          '&.Mui-selected': {
                            color: '#009C4E',
                          },
                        }}
                        disabled={!viewModel.isCreated}
                        label="Treinamentos"
                        value={2} />
                    </Tabs>
                  </Box>
                  {
                    viewModel.currentTab === 1 &&
                    <TabInformacoesGeraisContent
                      loading={viewModel.loading}
                      fileUploadUrl={viewModel.fileUploadUrl}
                      isCreated={viewModel.isCreated}
                      funcionario={viewModel.funcionario}
                      DocumetosLista={viewModel.documentos ?? []}
                      centroCustoLista={viewModel.filters.centroDeCustoLista ?? []}
                      hookFormEndereco={viewModel.hookFormEndereco}
                      hookForm={viewModel.hookForm}
                      onStartFileUpload={viewModel.handleStartFileUpload}
                      onDeleteFileUpload={viewModel.handleDeleteFileUpload}
                      onLoadCep={viewModel.handleLoadCep}
                      // Centro de custo secundario.

                      onSetCadastroCentroCustoSecundarioOpenState={viewModel.handleCadastroCentroCustoSecundarioOpenState}
                      onStartDeleteCentroCustoSecundario={viewModel.handleDeletarCentroCustoSecundarioOpenState}
                      centroCustoSecundarioLista={viewModel.centroCustoSecundarios ?? []}


                      //Documentos
                      onSetCadastroDocumentosOpenState={viewModel.handleCadastroDocumentoOpenState}
                      onSetDocumentosOpenState={viewModel.handleDocumentoOpenState}
                      onStartDeleteDocumentos={viewModel.handleDeletarDocumentoOpenState}
                      onDownload={viewModel.handleDownloadDocumento}
                    />
                  }
                  {
                    viewModel.currentTab === 2 &&
                    <TabTreinamentosContent
                      loading={viewModel.loading}
                      treinamentosLista={viewModel.funcionarioTreinamentos}
                      onCadastrar={viewModel.handleCadastroFuncionarioTreinamentoOpenState}
                      onAvaliar={viewModel.handleAvaliarFuncionarioTreinamentoOpenState}
                      onAvaliarLote={viewModel.handleAvaliarLoteTreinamentoOpenState}
                      onExportar={viewModel.handleReportFuncionarioTreinamento}
                      onEditar={viewModel.handleEditarFuncionarioTreinamento}
                      onDeletar={viewModel.handleDeletarFuncionarioTreinamentoOpenState}
                      onDeletarLote={viewModel.handleDeletarTreinamentosLoteOpenState} />
                  }
                </div>
              )
          }
        </div>

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.idFuncionario) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => null}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>
      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <CadastroCentroCustoSecundarioModal
        selectedCentroCustoSecundario={viewModel.selectedCentroCustoSecundario ?? null}
        open={viewModel.openCadastroCentroCustoSecundarioModal}
        saving={viewModel.saving}
        centroCustoLista={viewModel.filters.centroDeCustoLista ?? []}
        onSubmit={viewModel.handleSubmitCentroCustoSecundario}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)}
        onClose={() => viewModel.handleCadastroCentroCustoSecundarioOpenState(null, false)}
      />

      <CadastroDocumentoModal
        open={viewModel.openCadastroDocumentoModal}
        saving={viewModel.saving}
        selectedDocumento={viewModel.selectedDocumento ?? null}
        onSubmit={viewModel.handleSubmitDocumento}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)}
        onDownload={viewModel.handleDownloadDocumento}
        onClose={() => viewModel.handleCadastroDocumentoOpenState(null, false)}
      />

      <DocumentoModal
        open={viewModel.openDocumentoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onDownload={viewModel.handleDownloadDocumento}
        onClose={() => viewModel.handleDocumentoOpenState(null, false)}
        DocumetosLista={viewModel.documentos ?? []}
        onSetCadastroDocumentosOpenState={viewModel.handleCadastroDocumentoOpenState}
        onStartDeleteDocumentos={viewModel.handleDeletarDocumentoOpenState}
        handleClearFilters={viewModel.handleClearFilters}
        handleSituacao={viewModel.handleSituacaoChange}
        handleStatus={viewModel.handleStatusChange}
        pesquisa={viewModel.filtersDoc.pesquisa}
        situacao={viewModel.filtersDoc.situacao}
        status={viewModel.filtersDoc.status}
        NomeDocumento={viewModel.filtersDoc.NomeDocumento}
        handleNomeDocumento={viewModel.handleNomeDocumentoChange}
        DataDe={viewModel.filtersDoc.DataDe}
        DataAte={viewModel.filtersDoc.DataAte}
        onDataRangeChange={viewModel.handleDataRangeChange}
      />

      <CadastroTreinamentoModal
        open={viewModel.openCadastroFuncionarioTreinamentoModal}
        saving={viewModel.saving}
        selectedTreinamento={viewModel.selectedFuncionarioTreinamento ?? null}
        treinamentoLista={viewModel.filters.treinamentoLista ?? []}
        onSubmit={viewModel.handleSubmitTreinamento}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)}
        onClose={() => viewModel.handleCadastroFuncionarioTreinamentoOpenState(null, false)}
      />
      <DeleteDialog
        open={viewModel.openDeletarCentroCustoSecundarioModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarCentroCustoSecundarioOpenState(null, false)}
        title={`Você realmente deseja excluir este centro de custo secundário?`}
        onDelete={() => viewModel.handleConfirmarDeletarCentroCustoSecundario()}
      />
      <DeleteDialog
        open={viewModel.openDeletarDocumentoModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarDocumentoOpenState(null, false)}
        title={`Você realmente deseja excluir este centro de custo secundário?`}
        onDelete={() => viewModel.handleConfirmarDeletarDocumento()}
      />
      <DeleteDialog
        open={viewModel.openDeletarFuncionarioTreinamentoModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarFuncionarioTreinamentoOpenState(null, false)}
        title={`Você realmente deseja excluir este treinamento?`}
        onDelete={() => viewModel.handleConfirmarDeletarFuncionarioTreinamento()}
      />

      <AvaliarTreinamentoModal
        open={viewModel.openAvaliarFuncionarioTreinamentoModal}
        saving={viewModel.saving}
        selectedTreinamento={viewModel.selectedFuncionarioTreinamento ?? null}
        onSubmit={viewModel.handleSubmitAvaliarTreinamento}
        onClose={() => viewModel.handleAvaliarFuncionarioTreinamentoOpenState(null, false)}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)}
      />


    </>
  );
}